<template>
  <div class="wrapper">
    <!--头部-->
    <page-head :title="title" :btn-list="btnList" :show-back="false" @handleBtn="handleBtn">
      <div slot class="box tab-wrapper">
        <div class="tab-btn" @click="clickActive" :class="type == 'result'?'active':''">评选结果</div>
        <div class="tab-btn" @click="clickCaogao" :class="type == 'caogao'?'active':''">草稿</div>
      </div>
    </page-head>
    <Card v-if="isJiedao" style="margin: 0 20px;">
      <div class="select_box" v-if="isJiedao">
        <div style="margin-bottom: 10px;color: #333">行政区域</div>
        <Select v-model="community" style="width:410px" @on-change="change">
          <Option v-for="item in communityList" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
      </div>
    </Card>
    <!--列表-->
    <div style="padding: 20px">
      <Card v-for="(item,index) in vanguardList" :padding="0" class="card">
        <div @click="gotoEdit(item)">
          <!--头部  日期和更多-->
          <div class="box title-box">
            <!--日期-->
            <div class="_title box">
              <div class="box">评选日期&nbsp;{{item.time}}</div>
              <div class="box" style="margin-left: 40px">{{item.communityName}}</div>
            </div>
            <!-- <div class="_title box">{{item.communityName}}</div> -->
            <!--省略号-->
            <div class="more-wrapper box_v" @mouseenter="moreIndex=index" @mouseleave="moreIndex=-1">
              <div class="iconfont icon-caidan1"></div>
              <div v-if="moreIndex==index" class="more-content">
                <div
                  :style="{background:changeState?'#f1f1f1':''}"
                  @mouseover="change()"
                  @mouseout="change()"
                  class="text"
                  @click.stop="deleteList(item,index)"
                >{{type=='result'?'撤回':'删除'}}
                </div>
              </div>
            </div>
          </div>
          <div class="box memberList">
            <div v-for="_item in item.list" class="member-item">
              <img v-if="_item.pic" :src="_item.pic"/>
              <div v-else class="iconfont icon-img"></div>
              <div class="item-name">{{_item.name}}</div>
            </div>
          </div>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
  import pageHead from '../../../components/head'

  export default {
    name: 'beauty',
    components: {
      pageHead
    },
    data() {
      return {
        btnList: [{
          name: '发布',
          type: 'edit'
        }],
        changeState: false,//撤回删除 的悬浮状态
        moreIndex: -1,//当前卡片索引值
        type: 'result',
        vanguardList: [],
        communityList: [],
        community: parseInt(this.$store.state.streetorcommunityid),
        title: '最美网格长'
      }
    },
    computed: {
      isJiedao () {
        console.log(this.$store.state.isJiedao)
        return parseInt(this.$store.state.isJiedao);
      }
    },
    watch: {
      type() {
        this.getVanguard()
      },
    },
    methods: {
      clickActive() {
        this.type = 'result'
      },
      clickCaogao() {
        this.type = 'caogao'
      },
      // 撤回或者删除的悬浮状态改变
      change() {
        this.changeState = !this.changeState;
      },
      backList() {

      },
      deleteList(item,index) {
        var idList = item.list.map(item => {
          return item.id
        }).join(',')
        var url = this.urlobj.delVanguard+'idList='+idList+'&isDelete='+(this.type=='result'?0:1)//根据评选日期删除时传值:0--撤回到草稿，1--删除
        console.log(idList)
        this.$delete(url).then(res => {
          this.$Message.success('操作成功')
          this.vanguardList.splice(index, 1)
          this.showDel = false
        }).catch(e => {
        })

      },
      handleBtn(type) {
        if (type == 'edit') {
          this.$router.push({name: 'beautyEdit'})
        }
      },
      getVanguard() {
        var community = this.community
        var index = String(community).indexOf(',')
        var idlist = index == -1 ? [community] : community.split(',')
        var url = this.urlobj.getVanguard
        this.$post(url, {
          status: this.type == 'result' ? 1 : 0, //0--草稿, 1--已发布,
          communityIdList: idlist,
          comeType: 39
        }).then(res => {
          this.vanguardList = res.rows.map(item => {
            return {
              time: item.chooseTime,
              list: item.deedsList.map(item => {
                return {
                  pic: item.headPicUrl,
                  name: item.realName,
                  id:item.id,
                }
              }),
              communityName: item.communityName
            }
          })
        })
      },
      gotoEdit(item) {
        var status = this.type == 'result' ? 1 : 0
        this.$router.push({
          name: 'beautyEdit',
          query: {time: item.time, status}
        })
      },
      getCommunity() {
        var url = this.urlobj.getChildShequ;
        this.$get(url).then(res => {
          var ids = res.rows.map(item => {
            return item.communityId
          })
          ids = ids.join(',')
          var item = {
            name: '全部',
            id: ids
          }
          var list = res.rows.map(item => {
            return {
              name: item.communityName,
              id: item.communityId
            };
          });
          list.unshift(item)
          console.log(list)
          this.communityList = list
          this.community = parseInt(this.$store.state.streetorcommunityid)
        });
      },
      change(val) {
        this.getVanguard()
      }
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        console.log('==================')
        console.log(from)
        if(from.path == '/userManager/grid/beautyEdit'){
          vm.type = from.query.status==1?'result':'caogao'
        }
        vm.getVanguard()
      })
    },
    mounted() {
      if(this.$store.state.isJiedao) {
        this.getCommunity()
      }
    }
  }
</script>

<style scoped lang="less">
  .tab-wrapper {
    position: absolute;
    left: 20px;
    .tab-btn {
      height: 30px;
      line-height: 30px;
      width: 85px;
      text-align: center;
      background: #fff;
      color: #999;
      &:first-child {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }
      &:last-child {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }
    }
    .active {
      background: #ff7b44;
      color: #fff
    }
  }
  
  .card {
    width: 100%;
    margin-bottom: 20px;
    .title-box {
      padding: 20px;
      justify-content: space-between;
      align-items: center;
      line-height: 1;
      ._title {
        color: #999;
      }
      .more-wrapper {
        position: relative;
        width: 80px;
        text-align: right;
        .iconfont {
          color: #707070;
          font-size: 20px;
        }
        .more-content {
          width: 80px;
          background: #fff;
          position: absolute;
          bottom: 0;
          left: 0;
          transform: translateY(100%);
          padding: 10px 0;
          border: 1px solid #c7c7c7;
          text-align: center;
          color: #999999;
          border-radius: 4px;
          z-index: 10;
          .text {
            padding: 5px 0;
          }
        }
      }
    }
    .memberList {
      flex-wrap: wrap;
      line-height: 1;
      .member-item {
        margin: 0 20px;
        text-align: center;
        img {
          width: 90px;
          height: 125px;
          display: block;
          margin-bottom: 20px;
        }
        .iconfont{
          color:#d4d4d4;
          background: #f5f5f5;
          width: 90px;
          height: 125px;
          text-align: center;
          line-height: 125px;
          font-size: 40px;
          margin-bottom: 20px;
        }
        .item-name {
          margin-bottom: 20px;
          color: #333;
          font-size: 16px;
        }
      }
    }
  }
</style>
